// ─────────────────────────────────────────────────────────────
// apiConnect.js — axios client กลางสำหรับเรียก apiConnectSecure (ฟังก์ชันใหม่ auth จริง)
//
// แทน apiConnect เดิม (ที่ auth ปลอม — เทียบ static token หมดอายุที่ฝังใน bundle)
// ทุก request จะแนบ Firebase ID token "สด" ของผู้ใช้ที่ล็อกอินอยู่ให้อัตโนมัติ
//   - mConnect ล็อกอินเข้า project malin1-app-mconnect (ดู FirebaseConfig.jsx)
//   - apiConnectSecure verify token ของ malin1-app-mconnect → ผ่าน
//
// วิธีใช้: import apiConnect from '.../api/apiConnect'
//         await apiConnect.get('/v1/devices/all-device')   (ไม่ต้องใส่ base/headers เอง)
// ─────────────────────────────────────────────────────────────
import axios from 'axios'
import firebase from '../firebase/FirebaseConfig'

export const API_CONNECT_SECURE_BASE =
  'https://asia-southeast1-dygistechplatform.cloudfunctions.net/apiConnectSecure'

// รอ firebase auth พร้อม (ตอน reload หน้าแรง currentUser อาจ null ชั่วขณะ)
function waitForUser() {
  const auth = firebase.auth()
  if (auth.currentUser) return Promise.resolve(auth.currentUser)
  return new Promise((resolve, reject) => {
    const unsub = auth.onAuthStateChanged((u) => {
      unsub()
      if (u) resolve(u)
      else reject(new Error('ยังไม่ได้ล็อกอิน (ไม่มี currentUser)'))
    })
  })
}

const apiConnect = axios.create({ baseURL: API_CONNECT_SECURE_BASE })

// interceptor: แนบ Bearer token สดทุก request อัตโนมัติ
apiConnect.interceptors.request.use(async (config) => {
  const user = await waitForUser()
  const token = await user.getIdToken()
  config.headers.Authorization = `Bearer ${token}`
  return config
})

export default apiConnect
